import { c as _c } from "react/compiler-runtime";
import React, { ChangeEvent, useState } from 'react';
import { Box, Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, Typography, useTheme } from '@mui/material';
import { SignInFormProps } from './types';
import { Visibility, VisibilityOff } from '@mui/icons-material';
export default function LoginWithLdap(t0) {
  const $ = _c(23);
  const {
    show,
    showForm,
    showAbort,
    onLoginHandler
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      email: "",
      password: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [credentials, setCredentials] = useState(t1);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  let t2;
  if ($[1] !== showForm) {
    t2 = () => {
      showForm("ldap");
    };
    $[1] = showForm;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleShowForm = t2;
  let t3;
  if ($[3] !== showForm) {
    t3 = () => {
      showForm("");
    };
    $[3] = showForm;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleDontShowForm = t3;
  let t4;
  if ($[5] !== credentials) {
    t4 = e => {
      setCredentials({
        ...credentials,
        [e.target.id]: e.target.value
      });
    };
    $[5] = credentials;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const onChangeCredentialsHandler = t4;
  let t5;
  if ($[7] !== credentials.email || $[8] !== credentials.password || $[9] !== onLoginHandler) {
    t5 = async e_0 => {
      setError("");
      e_0.preventDefault();
      const res = await onLoginHandler(credentials.email, credentials.password);
      if (res === false) {
        setError("Invalid credentials");
      }
    };
    $[7] = credentials.email;
    $[8] = credentials.password;
    $[9] = onLoginHandler;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const loginHandler = t5;
  let t6;
  if ($[11] !== credentials.email || $[12] !== credentials.password || $[13] !== error || $[14] !== handleDontShowForm || $[15] !== handleShowForm || $[16] !== loginHandler || $[17] !== onChangeCredentialsHandler || $[18] !== show || $[19] !== showAbort || $[20] !== showPassword || $[21] !== theme) {
    t6 = <>{show ? <><Stack spacing={4}><Typography variant="h5" sx={{
            fontWeight: "bold",
            textAlign: "center"
          }}>Sign in with LDAP</Typography><form onSubmit={loginHandler}><FormControl variant="outlined" size="small" sx={{
              width: "100%",
              mb: 2
            }}><InputLabel htmlFor="email">Email</InputLabel><OutlinedInput id="email" label="Email" type="email" value={credentials.email} onChange={e_1 => onChangeCredentialsHandler(e_1)} autoComplete="email" /></FormControl><FormControl size="small" sx={{
              width: "100%",
              mb: 2
            }}><InputLabel htmlFor="password">Password</InputLabel><OutlinedInput id="password" label="Password" type={showPassword ? "text" : "password"} value={credentials.password} onChange={e_2 => onChangeCredentialsHandler(e_2)} aria-describedby="password-helper-text" autoComplete="password" endAdornment={<InputAdornment position="end"><IconButton aria-label="toggle password ability" onClick={() => setShowPassword(!showPassword)} edge="end">{showPassword ? <Visibility /> : <VisibilityOff />}</IconButton></InputAdornment>} /></FormControl>{error ? <Typography sx={{
              textAlign: "center",
              fontSize: 12,
              mb: 2,
              color: theme.palette.error.main
            }}>{error}</Typography> : null}<Button variant="contained" size="large" type="submit" fullWidth={true}>Sign in</Button></form></Stack>{showAbort ? <Box sx={{
          marginTop: 4
        }}><Button variant="outlined" fullWidth={true} onClick={handleDontShowForm}>Cancel</Button></Box> : null}</> : <Button variant="outlined" fullWidth={true} onClick={handleShowForm}>Sign in with LDAP</Button>}</>;
    $[11] = credentials.email;
    $[12] = credentials.password;
    $[13] = error;
    $[14] = handleDontShowForm;
    $[15] = handleShowForm;
    $[16] = loginHandler;
    $[17] = onChangeCredentialsHandler;
    $[18] = show;
    $[19] = showAbort;
    $[20] = showPassword;
    $[21] = theme;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}